import { createAction, props } from '@ngrx/store';
import { UserGroup } from '../_models/userGroup';

// Action types
export const loadUserGroups = createAction('[UserGroup] Load UserGroups');
export const loadUserGroupsSuccess = createAction(
  '[UserGroup] Load UserGroups Success',
  props<{ userGroups: UserGroup[] }>()
);
export const loadUserGroupsFailure = createAction(
  '[UserGroup] Load UserGroups Failure',
  props<{ error: any }>()
);

export const addUserGroup = createAction(
  '[UserGroup] Add UserGroup',
  props<{ userGroup: UserGroup }>()
);
export const addUserGroupSuccess = createAction(
  '[UserGroup] Add UserGroup Success',
  props<{ userGroup: UserGroup }>()
);
export const addUserGroupFailure = createAction(
  '[UserGroup] Add UserGroup Failure',
  props<{ error: any }>()
);

export const updateUserGroup = createAction(
  '[UserGroup] Update UserGroup',
  props<{ userGroup: UserGroup }>()
);
export const updateUserGroupSuccess = createAction(
  '[UserGroup] Update UserGroup Success',
  props<{ userGroup: UserGroup }>()
);
export const updateUserGroupFailure = createAction(
  '[UserGroup] Update UserGroup Failure',
  props<{ error: any }>()
);

export const deleteUserGroup = createAction(
  '[UserGroup] Delete UserGroup',
  props<{ id: number }>()
);
export const deleteUserGroupSuccess = createAction(
  '[UserGroup] Delete UserGroup Success',
  props<{ id: number }>()
);
export const deleteUserGroupFailure = createAction(
  '[UserGroup] Delete UserGroup Failure',
  props<{ error: any }>()
);
